import { useEffect, useState } from 'react';
import { message, Table, Button, Card, Space, Collapse, Row, Col, Input, Popconfirm, Typography, Divider } from 'antd';
import { notifyMessages, tablePageSize } from '../../utils/constants';
import { PageHeader } from '../../components/common/pageHeader';
import { PlusOutlined, WarningOutlined, DeleteFilled } from '@ant-design/icons';
import SuppliersServices from '../../services/suppliersServices';
import NewSupplier from './newSupplier';
import UpdateSupplier from './updateSupplier';
import { handleDateConvertDayJs } from '../../utils/functions';
import "./suppliers.scss";
import { useCurrentUserContext } from '../../context/currentUserContext';
import { isSuperAdmin } from '../../configs/auth/roleRights';
const { Link } = Typography;

const initialFilters = {
    name: "",
    vatCode: "",
    enabled: true
}

const SuppliersList = () => {
    const { currentUser } = useCurrentUserContext();

    const [filters, setFilters] = useState(initialFilters);
    const [suppliers, setSuppliers] = useState([]);

    const [loadingData, setLoadingData] = useState([]);
    const [openCreateDrawer, setOpenCreateDrawer] = useState(false);
    const [openUpdateDrawer, setOpenUpdateDrawer] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);

    useEffect(() => {
        getSuppliers(initialFilters);
    }, []);

    const showDrawer = (drawerName, record) => {
        if (drawerName === "create") setOpenCreateDrawer(true);
        if (drawerName === "update") setOpenUpdateDrawer(true); setSelectedRecord(record);
    }

    const onCloseDrawer = (drawerName) => {
        if (drawerName === "create") setOpenCreateDrawer(false);
        if (drawerName === "update") setOpenUpdateDrawer(false);
    };


    const getSuppliers = async (appliedFilters) => {
        // appliedFilters['categoryID'] = currentUser.lastSelectedCategory;
        appliedFilters['availableSuppliers'] = false;
        appliedFilters['userID'] = currentUser.id;
        setLoadingData(true);
        try {
            const respData = await SuppliersServices.getSuppliers(appliedFilters);

            if (respData.success) {
                let result = respData.responseObject.value;
                setSuppliers(result.supplierListDTO);
                setLoadingData(false);
            }
            else {
                message.error(notifyMessages.errorAccured);
                setLoadingData(false);
            }

        } catch (error) {
            message.error(notifyMessages.errorAccured);
            setLoadingData(false);
        }
    };

    const onRemoveSupplier = async (supplierId) => {
        try {
            const respData = await SuppliersServices.deleteSupplier(supplierId);

            if (respData.success) {
                message.success(notifyMessages.operationSuccess);
                getSuppliers(initialFilters);
            }
            else {
                message.error(notifyMessages.errorAccured);
            }
        } catch (error) {
            message.error(notifyMessages.errorAccured);
        }
    };

    const columns = [
        {
            title: 'Nome',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Partita Iva',
            dataIndex: 'vatCode',
            key: 'vatCode',
        },
        {
            title: 'Data Caricamento',
            dataIndex: 'creationDate',
            key: 'creationDate',
            render: (_, record) => record.creationDate ? handleDateConvertDayJs(record.creationDate) : ''
        },
        {
            key: "action",
            width: "50px",
            render: (_, record) => {
                return (
                    <Space>
                        <Link style={{ color: "#0f4d65" }} onClick={() => showDrawer("update", record)}>Apri</Link >
                    </Space>
                )
            }
        },
        {
            key: "action2",
            width: "30px",
            render: (_, record) => {
                return (
                    <>
                        {isSuperAdmin(currentUser) && (
                            <Popconfirm
                                placement="topRight"
                                key="remove"
                                title="Vuoi eliminare questo manutentore?"
                                icon={<WarningOutlined style={{ color: '#f7c924' }} />}
                                okText="Si"
                                cancelText="No"
                                onConfirm={() => onRemoveSupplier(record.id)}
                            >
                                <DeleteFilled style={{ color: '#023B72' }} title={"Elimina Manutentore"} />
                            </Popconfirm>
                        )}
                    </>
                )
            }
        }
    ];

    const onFilter = () => {
        getSuppliers(filters);
    }

    const onClearFilters = () => {
        setFilters(initialFilters);
        getSuppliers(initialFilters);
    }

    const handelFilterChange = (name, value) => {
        setFilters((prev) => ({ ...prev, [name]: value }));
    }

    const panelItems = [
        {
            key: '1',
            label: 'Filtra',
            children: (
                <>
                    <Row gutter={{ lg: 24 }}>
                        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 6 }}>
                            <Space direction='vertical'>
                                <span>Nome</span>
                                <Input value={filters.name} onChange={(e) => handelFilterChange("name", e.target.value)} />
                            </Space>
                        </Col>

                        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 6 }}>
                            <Space direction='vertical'>
                                <span>Partita IVA</span>
                                <Input value={filters.vatCode} onChange={(e) => handelFilterChange("vatCode", e.target.value)} />
                            </Space>
                        </Col>
                    </Row>

                    <Divider />
                    <Row gutter={{ lg: 24 }}>
                        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                            <Button type="primary" style={{ marginRight: 10 }} onClick={() => onFilter()}> Filtra </Button>
                            <Button onClick={() => onClearFilters()}> Rimuovi  </Button>
                        </Col>
                    </Row>
                </>
            )
        }
    ]

    return (
        <div className="supllierContainer">

            <NewSupplier open={openCreateDrawer} onClose={() => onCloseDrawer("create")} getSuppliers={() => getSuppliers(initialFilters)} />

            {selectedRecord && (
                <UpdateSupplier open={openUpdateDrawer} onClose={() => onCloseDrawer("update")} getSuppliers={() => getSuppliers(initialFilters)} recordData={selectedRecord} />
            )}

            <PageHeader title="Gestione Manutentori" />

            <Row gutter={{ lg: 24 }} className="supllierContainer filters-collapse">
                <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                    <Collapse size='small' className='filterPanel' items={panelItems} defaultActiveKey={['1']} />
                </Col>
            </Row>

            <Card extra={<Button type="primary" onClick={() => showDrawer("create")} icon={<PlusOutlined />}>Aggiungi</Button>}>
                <Table
                    className='customTableRows'
                    rowClassName={(_, index) =>
                        index % 2 === 0 ? 'table-row-light' : 'table-row-dark'
                    }
                    dataSource={suppliers}
                    columns={columns}
                    rowKey={obj => obj.id}
                    pagination={{
                        pageSize: tablePageSize
                    }}
                    loading={loadingData}
                    size='small'
                    bordered
                />
            </Card>
        </div>
    )
}
export default SuppliersList;